import styled from 'styled-components';
import { theme } from '../../utils/theme'

const TextHeader = styled.h2`
  margin: 0 0 20px;
  font-size: 30px;
  font-weight: ${({ theme }) => theme.font.light};
  text-align: ${({ align }) => (align ? align : 'center')};
  color: ${({ theme }) => theme.colors.white};

  :before {
      display: block;
      width: 250px;
      height: 4px;
      margin-top: 0;
      margin-left: ${({ align }) => (align ? 0 : 'auto')};
      margin-right: ${({ align }) => (align ? 0 : 'auto')};
      margin-bottom: 20px;
      background: ${({ white }) => (white ? theme.colors.white : theme.colors.primary)};
      content: '';
  }
`

export default TextHeader